import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';
const NAME = 'ResetFilters';

class ResetFilters extends BaseComponent {

	constructor(element) {
		super(element);
		this._element = element;
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		EventHandler.on(this._element, 'click', () => {
			const url = new URL(window.location),
				params = new URLSearchParams(url.search),
				lat = params.get('latitude'),
				lng = params.get('longitude');

			window.location = !lat ? window.location.origin + window.location.pathname :
				window.location.origin + window.location.pathname + '?latitude='+lat + '?longitude=' + lng;
		});
	}
}

export default ResetFilters;
